import React from "react";

function Header() {

    return (
        <div id="header">
            <h1>Teaching Charts</h1>
        </div>
    )
}

export default Header;